"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorTimeLedgerSchema = exports.SegmentEndReasons = exports.OPERATOR_TIME_PIN_BUCKETS = exports.MIN_BUCKET_PASSES = exports.MIN_OPERATOR_PASSES = exports.OPERATOR_TIME_IQR_MULTIPLIER = exports.MAX_REVIEW_DURATION_HOURS = exports.MIN_SECONDS_PER_PIN = exports.EVAL_EXECUTION_MODE = exports.DEFAULT_TIME_LEDGER_LOOKBACK_DAYS = void 0;
const zod_1 = require("zod");
exports.DEFAULT_TIME_LEDGER_LOOKBACK_DAYS = 90;
exports.EVAL_EXECUTION_MODE = 'operatorEval';
exports.MIN_SECONDS_PER_PIN = 15;
exports.MAX_REVIEW_DURATION_HOURS = 4;
exports.OPERATOR_TIME_IQR_MULTIPLIER = 1.5;
exports.MIN_OPERATOR_PASSES = 8;
exports.MIN_BUCKET_PASSES = 20;
exports.OPERATOR_TIME_PIN_BUCKETS = [
    { key: 'b1', label: '1–3', minPins: 1, maxPins: 3 },
    { key: 'b2', label: '4–8', minPins: 4, maxPins: 8 },
    { key: 'b3', label: '9–16', minPins: 9, maxPins: 16 },
    { key: 'b4', label: '17–32', minPins: 17, maxPins: 32 },
    { key: 'b5', label: '33–64', minPins: 33, maxPins: 64 },
    { key: 'b6', label: '65–300', minPins: 65, maxPins: 300 },
];
exports.SegmentEndReasons = ['submitted', 'released', 'expired', 'superseded'];
const operatorTimeSegmentSchema = zod_1.z.object({
    operatorId: zod_1.z.string(),
    operatorEmail: zod_1.z.string().nullable(),
    operatorName: zod_1.z.string().nullable(),
    username: zod_1.z.string().nullable(),
    planId: zod_1.z.string(),
    reviewId: zod_1.z.string().nullable(),
    generatorName: zod_1.z.string(),
    executionMode: zod_1.z.string().nullable(),
    packageId: zod_1.z.string().nullable(),
    packageName: zod_1.z.string().nullable(),
    manufacturerPartNumber: zod_1.z.string().nullable(),
    packagePinCountInitialEstimate: zod_1.z.number().nullable(),
    publishedPackagePinCount: zod_1.z.number().nullable(),
    sigmaModelType: zod_1.z.string().nullable(),
    stepId: zod_1.z.string(),
    stepType: zod_1.z.string(),
    startedAtUtc: zod_1.z.string(),
    endedAtUtc: zod_1.z.string(),
    heldSeconds: zod_1.z.number(),
    engagedSeconds: zod_1.z.number().nullable(),
    endReason: zod_1.z.enum(exports.SegmentEndReasons),
    passNumber: zod_1.z.number(),
});
const operatorStepTimingSchema = zod_1.z.object({
    operatorId: zod_1.z.string(),
    operatorEmail: zod_1.z.string().nullable(),
    operatorName: zod_1.z.string().nullable(),
    username: zod_1.z.string().nullable(),
    planId: zod_1.z.string(),
    reviewId: zod_1.z.string().nullable(),
    generatorName: zod_1.z.string(),
    executionMode: zod_1.z.string().nullable(),
    packageId: zod_1.z.string().nullable(),
    packageName: zod_1.z.string().nullable(),
    manufacturerPartNumber: zod_1.z.string().nullable(),
    packagePinCountInitialEstimate: zod_1.z.number().nullable(),
    publishedPackagePinCount: zod_1.z.number().nullable(),
    sigmaModelType: zod_1.z.string().nullable(),
    stepId: zod_1.z.string(),
    stepType: zod_1.z.string(),
    startedAtUtc: zod_1.z.string(),
    endedAtUtc: zod_1.z.string(),
    heldSeconds: zod_1.z.number(),
    engagedSeconds: zod_1.z.number().nullable(),
    idleSeconds: zod_1.z.number().nullable(),
    engagementRatio: zod_1.z.number().nullable(),
    viewingCount: zod_1.z.number(),
    status: zod_1.z.string(),
});
const reviewRollupEntrySchema = zod_1.z.object({
    reviewId: zod_1.z.string(),
    planId: zod_1.z.string(),
    generatorName: zod_1.z.string(),
    executionMode: zod_1.z.string().nullable(),
    packageId: zod_1.z.string().nullable(),
    packageName: zod_1.z.string().nullable(),
    manufacturerPartNumber: zod_1.z.string().nullable(),
    packagePinCountInitialEstimate: zod_1.z.number().nullable(),
    publishedPackagePinCount: zod_1.z.number().nullable(),
    sigmaModelType: zod_1.z.string().nullable(),
    completedAt: zod_1.z.string().nullable(),
    operatorIds: zod_1.z.array(zod_1.z.string()),
    startedAtUtc: zod_1.z.string(),
    endedAtUtc: zod_1.z.string(),
    heldSeconds: zod_1.z.number(),
    engagedSeconds: zod_1.z.number().nullable(),
    stepCount: zod_1.z.number(),
    viewingCount: zod_1.z.number(),
});
const operatorDailySummarySchema = zod_1.z.object({
    operatorId: zod_1.z.string(),
    operatorName: zod_1.z.string().nullable(),
    username: zod_1.z.string().nullable(),
    date: zod_1.z.string(),
    executionMode: zod_1.z.string().nullable(),
    estimatedEngagedHours: zod_1.z.number(),
    measuredEngagedHours: zod_1.z.number().nullable(),
    presenceHours: zod_1.z.number(),
    reviewsCompleted: zod_1.z.number(),
    totalPins: zod_1.z.number(),
});
const operatorWeeklySummarySchema = zod_1.z.object({
    operatorId: zod_1.z.string(),
    operatorName: zod_1.z.string().nullable(),
    username: zod_1.z.string().nullable(),
    weekKey: zod_1.z.string(),
    weekStart: zod_1.z.string(),
    weekEnd: zod_1.z.string(),
    executionMode: zod_1.z.string().nullable(),
    estimatedEngagedHours: zod_1.z.number(),
    measuredEngagedHours: zod_1.z.number().nullable(),
    presenceHours: zod_1.z.number(),
    reviewsCompleted: zod_1.z.number(),
    totalPins: zod_1.z.number(),
});
exports.operatorTimeLedgerSchema = zod_1.z.object({
    generatedAt: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    segments: zod_1.z.array(operatorTimeSegmentSchema),
    stepTimings: zod_1.z.array(operatorStepTimingSchema),
    reviewRollup: zod_1.z.array(reviewRollupEntrySchema),
    dailyOperatorSummary: zod_1.z.array(operatorDailySummarySchema),
    weeklyOperatorSummary: zod_1.z.array(operatorWeeklySummarySchema),
});
//# sourceMappingURL=operator-time-ledger.js.map